import { render } from "./FloatingMenu.vue?vue&type=template&id=22a2b6db&scoped=true"
import script from "./FloatingMenu.vue?vue&type=script&lang=js"
export * from "./FloatingMenu.vue?vue&type=script&lang=js"

import "./FloatingMenu.vue?vue&type=style&index=0&id=22a2b6db&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a2b6db"]])

export default __exports__